'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _boxModel = require('@/components/base/box-model');

var _boxModel2 = _interopRequireDefault(_boxModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      showBox: true
    };
  },
  mounted: function mounted() {
    //如果没有slot插入，我们直接去除这个节点
    !this.$slots.default && (this.showBox = false);
  },

  components: {
    BoxModel: _boxModel2.default
  }
}; //
//
//
//
//
//
//
//
//